<template>
  <van-dialog
    :value="show"
    class="pwc-item"
    title="用户条款"
    show-cancel-button
    confirm-button-text="同意"
    @cancel="handleCancel"
    @confirm="handleOk"
  >
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="pwc-item-detail" v-html="term" />
  </van-dialog>
</template>

<script>
import { logic } from '../common/mixin/logic'

export default {
  mixins: [logic]
}
</script>

<style lang="scss" scoped>
.pwc-item {
  .pwc-item-detail {
    max-height: 360px;
    overflow: scroll;
    overflow-x: hidden;
    padding: 12px;
  }
}
</style>

<style lang="scss">
.pwc-item {
  .van-dialog__header {
    padding-top: 18px;
    margin-bottom: 12px;
  }
}
</style>

